import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/packages/app/src/app/error.tsx");
